<!-- Primary Navigation (Bottom) - Main Navigation Bar -->
<header
  aria-label="Website-Navigation"
  [class.open]="menuIsOpen"
  class="tw:backdrop-blur-sm tw:shadow-sm"
>
  <a
    routerLink=""
    routerLinkActive="active"
    [title]="'COMPONENTS.LANDING_PAGE' | translate"
    class="logo"
    queryParamsHandling="merge"
    (click)="menuIsOpen = false"
  >
    <vee-logo></vee-logo>
  </a>
  <div class="mobile-interactions">
    <!-- Primary Navigation Items (Mobile) -->
    @for (item of primaryNavigation; track $index) {
      @if (shouldShowItem(item)) {
        <a
          vee-link="filled"
          [class]="color == 'white' ? 'cyan' : color"
          [icon]="item.icon"
          [routerLink]="item.route"
          [class.active]="active == item.id"
          routerLinkActive="active"
          queryParamsHandling="merge"
          (click)="menuIsOpen = false"
          class="tw:hidden! tw:sm:flex!"
        >
          {{ item.label | translate }}
        </a>
      }
    }
    <a
      class="menu-btn secondary"
      [attr.aria-expanded]="menuIsOpen"
      aria-controls="menu"
      [class.open]="menuIsOpen"
      (click)="menuIsOpen = !menuIsOpen"
    >
      <vee-icon
        size="lg"
        class="tw:ml-3 tw:text-black"
        [icon]="menuIsOpen ? 'close' : 'menu'"
      ></vee-icon>
    </a>
  </div>
  <nav
    id="menu"
    aria-label="Hauptnavigation"
    class="main-nav height-transition menu"
  >
    <ul
      class="height-transition-inner tw:flex! tw:justify-end! tw:gap-1 tw:lg:gap-6"
    >
      <!-- Main Navigation Items -->
      @for (item of mainNavigation; track $index; let i = $index) {
        <!-- Submenu Items -->
        @if (isNavigationSubmenu(item) && shouldShowItem(item)) {
          <li class="submenu-trigger" [class.open]="openSubmenuIndex === i">
            <a
              vee-link="underlined"
              class="cyan tw:justify-start"
              [class.active]="openSubmenuIndex === i"
              aria-haspopup="true"
              [attr.aria-expanded]="openSubmenuIndex === i"
              [attr.aria-controls]="'submenu' + i"
              icon="angleClosed"
              (click)="toggleSubmenu(i)"
              (mouseenter)="openSubmenuOnHover(i)"
              (mouseleave)="scheduleSubmenuClose()"
            >
              {{ item.label | translate }}
            </a>
            <div
              class="height-transition submenu"
              (mouseenter)="openSubmenuOnHover(i)"
              (mouseleave)="scheduleSubmenuClose()"
            >
              <ul
                [id]="'submenu' + i"
                [attr.aria-label]="'Untermenü für ' + item.label"
                class="height-transition-inner submenu-grid"
              >
                @for (subItem of item.items; track $index) {
                  @if (shouldShowSubmenuItem(subItem)) {
                    <li>
                      <a
                        [routerLink]="subItem.route"
                        routerLinkActive="active"
                        queryParamsHandling="merge"
                        (click)="menuIsOpen = false; closeSubmenu()"
                      >
                        @if (subItem.icon) {
                          <span class="submenu-icon">
                            <vee-icon [icon]="subItem.icon"></vee-icon>
                          </span>
                        }
                        {{ subItem.label | translate }}
                      </a>
                    </li>
                  }
                }
              </ul>
            </div>
          </li>
        }

        <!-- Regular Navigation Items -->
        @if (isNavigationItem(item) && shouldShowItem(item)) {
          <li>
            <a
              vee-link="underlined"
              [class]="item.color + ' tw:justify-start'"
              [class.active]="item.route ? isRouteActive(item.route) : false"
              [routerLink]="item.route"
              routerLinkActive="active"
              queryParamsHandling="merge"
              (click)="menuIsOpen = false"
            >
              {{ item.label | translate }}
            </a>
          </li>
        }
      }

      <li>
        @for (item of primaryNavigation; track $index) {
          @if (shouldShowItem(item)) {
            <a
              vee-link="filled"
              [class]="color == 'white' ? 'cyan' : color"
              [icon]="item.icon"
              [routerLink]="item.route"
              [class.active]="active == item.id"
              routerLinkActive="active"
              queryParamsHandling="merge"
              (click)="menuIsOpen = false"
              class="tw:flex! tw:sm:hidden!"
            >
              {{ item.label | translate }}
            </a>
          }
        }
      </li>

      <!-- Mobile Only Navigation -->
      @for (item of mobileOnlyNavigation; track $index) {
        @if (shouldShowItem(item)) {
          <li class="mobile-only tw:mx-2 tw:my-1">
            <a
              [attr.vee-link]="
                item.style === 'underlined' ? 'underlined' : null
              "
              [class]="item.color + ' tw:justify-start'"
              [class.active]="item.route ? isRouteActive(item.route) : false"
              [routerLink]="item.route"
              routerLinkActive="active"
              queryParamsHandling="merge"
              (click)="handleNavigationAction(item); menuIsOpen = false"
              tabindex="0"
              role="button"
              [attr.aria-label]="item.label"
            >
              @if (item.icon) {
                <vee-icon [icon]="item.icon"></vee-icon>
              }
              {{ item.label | translate }}
            </a>
          </li>
        }
      }
    </ul>
  </nav>
</header>

<!-- Secondary Navigation (Top) - Utility Navigation -->
<nav
  class="secondary-nav tw:bg-white tw:w-full tw:py-2"
  aria-label="Sekundäre Navigation"
>
  <ul class="tw:flex tw:justify-end tw:gap-1 tw:lg:gap-6 tw:m-0">
    @for (item of secondaryNavigation; track $index) {
      @if (shouldShowItem(item)) {
        <li>
          <a
            [attr.vee-link]="item.style === 'underlined' ? 'underlined' : null"
            [class]="item.color + ' tw:justify-start'"
            [class.active]="item.route ? isRouteActive(item.route) : false"
            [routerLink]="item.route"
            routerLinkActive="active"
            queryParamsHandling="merge"
            (click)="handleNavigationAction(item); menuIsOpen = false"
            tabindex="0"
            role="button"
            [attr.aria-label]="item.label"
          >
            @if (item.icon) {
              <vee-icon [icon]="item.icon" [class]="'left'"></vee-icon>
            }
            {{ item.label | translate }}
          </a>
        </li>
      }
    }
  </ul>
</nav>
